import { useRouter } from "next/router";
import { useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";
import PrimaryBtn from "@/components/button/primaryBtn";
import { useRegisterByPhone } from "@/api/client/auth";
import AppInput from "@/components/form/input-field";
import { signUpWithPhoneSchema } from "@/utils/validation/schema/auth";
import { errorToast } from "@/utils/toast";
import { removeGuestUser } from "@/services/guest-user";
import { useGetNotification } from "@/api/client/notification";
import { updateCartItemCount } from "@/store/feature/cartSlice";
import { updateWishlistItemCount } from "@/store/feature/wishlistSlice";
import { useDispatch } from "react-redux";
import { signIn } from "next-auth/react";

function NewUserForm({ phone, signature }) {
  const router = useRouter();
  const dispatch = useDispatch();

  const { refetch: fetchNotification } = useGetNotification({
    enabled: false,
    onSuccess: (notification) => {
      dispatch(updateCartItemCount(notification.cart_product_count));
      dispatch(updateWishlistItemCount(notification.wishlist_product_count));
    },
  });

  const { isLoading: isRegisterLoading, mutate: registerByPhone } =
    useRegisterByPhone({
      onSuccess: async (successData) => {
        const authRes = await signIn("credentials", {
          redirect: false,
          user: JSON.stringify(successData.data.customer),
          token: successData.data.token,
        });
        if (authRes.ok) {
          fetchNotification();
          removeGuestUser();
          router.push(router.query.from || router.query.callbackUrl || "/");
        }
      },
      onError: (errorData) => {
        errorData.errors.forEach(({ name, message }) => {
          setError(name, { message });
        });
        errorToast(errorData?.message);
      },
    });

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onBlur",
    resolver: yupResolver(signUpWithPhoneSchema),
  });

  const registerUser = (data) => {
    const payload = {
      full_name: data.full_name,
      email: data.email,
      phone,
      reg_signature: signature,
    };
    registerByPhone(payload);
  };

  return (
    <form className="sm:w-[480px]" onSubmit={handleSubmit(registerUser)}>
      <h1 className="mb-8 text-grayD1 text-[1.75rem] tracking-[0.14px] font-semibold">
        Please fill the Information
      </h1>
      <div className="space-y-[1.125rem]">
        <AppInput
          labelName="Full Name"
          type="text"
          placeholder="Enter full name"
          name="full_name"
          isFieldRequired
          register={register}
          error={errors.full_name}
        />

        <AppInput
          labelName="Email Address"
          type="text"
          placeholder="Enter email address"
          name="email"
          isFieldRequired
          register={register}
          error={errors.email}
        />
      </div>

      <PrimaryBtn
        btnText="Submit"
        className="w-full h-[3.5rem] mt-[1.875rem]"
        isLoading={isRegisterLoading}
      />
    </form>
  );
}

export default NewUserForm;
